import Vue from 'vue'
import Vuetify from 'vuetify'
import fr from 'vuetify/src/locale/fr'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)
Vue.use(Vuetify, {
  theme: {
    themes: {
      'primary': '#CD2B2F',
      'secondary': '#ef9a9a',
      'accent': '#469D61',
      'error': '#FF5252',
      'info': '#2196F3',
      'success': '#4CAF50',
      'warning': '#FFC107',
      'transco-green': '#469d61',
      'transco-light-blue': '#4fc3f7',
      'transco-brown': '#795548',
      'transco-light-purple': '#6176ff',
      'transco-yellow': '#ecbf41',
      'transco-red': '#cd2b2f',
      'transco-grey': '#9b9b9b',
      'transco-light-grey': '#f2f2f2',
    },
    options: {
      customProperties: true,
    },
  },
})

const messages = {
  fr : {
    $vuetify: {
      dataTable: fr.dataTable,
      dataIterator: fr.dataIterator,
      dataFooter: fr.dataFooter,
    },
  },
}

const i18n = new VueI18n({
  locale: 'fr', // set locale
  messages,
})

export default new Vuetify({
  icons: {
    iconfont: 'mdi',
  },
  lang: {
    t: (key: any, ...params: any) => i18n.t(key, params),
  },
})
